module.exports = __webpack_public_path__ + "static/media/cf-logo.5ab62565.svg";